// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-SimpleTable-styles___tableHead--wzRgf {
  color: #1b2432 !important;
  font-weight: 500 !important;
  font-size: 15px !important;
}

.components-SimpleTable-styles___tableRow--i84k8:last-child .components-SimpleTable-styles___tableRowCell--wwFIG {
      border: none;
    }

.components-SimpleTable-styles___tableRow--i84k8:hover {
    background: #f6f6f7;
  }

.components-SimpleTable-styles___tableRowCell--wwFIG {
  padding: 4px 24px 4px 24px !important;
  font-size: 15px !important;
  max-width: 220px !important;
  text-overflow: ellipsis;
  overflow: hidden;
}

.components-SimpleTable-styles___wideTable--uD8gz .components-SimpleTable-styles___tableHead--wzRgf,
  .components-SimpleTable-styles___wideTable--uD8gz .components-SimpleTable-styles___tableRowCell--wwFIG {
    padding: 4px 0px 4px 12px !important;
  }

.components-SimpleTable-styles___noBorder--hW856 {
  border: none !important;
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.05);
}

.components-SimpleTable-styles___scrollVertical--wH3Ew {
  overflow-x: auto;
}
`, "",{"version":3,"sources":["webpack://./components/SimpleTable/styles.pcss"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAII;MACE,YAAY;IACd;;AAGF;IACE,mBAAmB;EACrB;;AAGF;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,gBAAgB;AAClB;;AAGE;;IAEE,oCAAoC;EACtC;;AAGF;EACE,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".tableHead {\n  color: #1b2432 !important;\n  font-weight: 500 !important;\n  font-size: 15px !important;\n}\n\n.tableRow {\n  &:last-child {\n    .tableRowCell {\n      border: none;\n    }\n  }\n\n  &:hover {\n    background: #f6f6f7;\n  }\n}\n\n.tableRowCell {\n  padding: 4px 24px 4px 24px !important;\n  font-size: 15px !important;\n  max-width: 220px !important;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.wideTable {\n  .tableHead,\n  .tableRowCell {\n    padding: 4px 0px 4px 12px !important;\n  }\n}\n\n.noBorder {\n  border: none !important;\n  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.05);\n}\n\n.scrollVertical {\n  overflow-x: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableHead": `components-SimpleTable-styles___tableHead--wzRgf`,
	"tableRow": `components-SimpleTable-styles___tableRow--i84k8`,
	"tableRowCell": `components-SimpleTable-styles___tableRowCell--wwFIG`,
	"wideTable": `components-SimpleTable-styles___wideTable--uD8gz`,
	"noBorder": `components-SimpleTable-styles___noBorder--hW856`,
	"scrollVertical": `components-SimpleTable-styles___scrollVertical--wH3Ew`
};
module.exports = ___CSS_LOADER_EXPORT___;
